const API_BASE = 'https://counsellor.echobuddy.in/api/v1/messaging';
const API_COUNSELLOR_BASE = 'https://echoshine.in/api/v1/users';


export const createConversation = async (customerId, doctorId, appointmentId = null) => {
  const response = await fetch(`${API_BASE}/conversations`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      customer_id: customerId,
      doctor_id: doctorId,
      appointment_id: appointmentId,
    }),
  });
  return response.json();
};

export const getConversations = async (userType, userId) => {
  const response = await fetch(
    `${API_BASE}/conversations?user_type=${userType}&user_id=${userId}`
  );
  return response.json();
};

export const getMessages = async (conversationId, page = 1, limit = 50) => {
  const response = await fetch(
    `${API_BASE}/messages/${conversationId}?page=${page}&limit=${limit}`
  );
  return response.json();
};

export const sendMessage = async (messageData) => {
  const response = await fetch(`${API_BASE}/messages`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(messageData),
  });
  return response.json();
};

export const markAsRead = async (conversationId, userType) => {
  const response = await fetch(
    `${API_BASE}/messages/${conversationId}/read?user_type=${userType}`,
    { method: 'PUT' }
  );
  return response.json();
};

export const getUnreadCount = async (userType, userId) => {
  const response = await fetch(
    `${API_BASE}/unread-count?user_type=${userType}&user_id=${userId}`
  );
  return response.json();
};

export const getUserById = async (userId) => {
  try {
    const response = await fetch(`${API_COUNSELLOR_BASE}/${userId}`);

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to fetch user");
    }

    const data = await response.json();
    return data.user; // user object
  } catch (error) {
    console.error("Error fetching user:", error);
    throw error; // propagate error to caller
  }
};
